'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useTreatment } from '../lib/useFetchTreatments';
import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';
import styled from 'styled-components';
import { THUNDERDOME } from 'HubStyleTokens/colors';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIImage from 'UIComponents/image/UIImage';
import { adsAccountsVideo, adsOptimizationVideo, adsTargetingVideo, playEmbedAcademyExp, externallinkEmbedAcademyExp } from 'AdsUI/lib/Images';
import H5 from 'UIComponents/elements/headings/H5';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import Small from 'UIComponents/elements/Small';
import { useState, useEffect } from 'react';
import PortalIdParser from 'PortalIdParser';
const TOOL_TIP_LAYOUT = {
  targeting: {
    image: adsTargetingVideo,
    link: `https://app.hubspot.com/academy/${PortalIdParser.get()}/lessons/788/4027`
  },
  optimization: {
    image: adsOptimizationVideo,
    link: `https://app.hubspot.com/academy/${PortalIdParser.get()}/tracks/118/795/4063`
  },
  accounts: {
    image: adsAccountsVideo,
    link: `https://app.hubspot.com/academy/${PortalIdParser.get()}/lessons/486/2610`
  }
};
const ACADEMY_ACCOUNTS = 'accounts';
export default function AdsAcademyVideoCTA({
  option,
  showDetails = false
}) {
  const inVariant = useTreatment();
  const layout = TOOL_TIP_LAYOUT[option];
  const [imageReady, setImageReady] = useState(false);
  useEffect(() => {
    const img = new Image();

    img.onload = () => {
      setImageReady(true);
    };

    img.src = layout.image;
  }, [layout.image]);
  const StyledButton = styled(UIButton).withConfig({
    displayName: "AdsAcademyVideoCTA__StyledButton",
    componentId: "sc-7euzkv-0"
  })(["border-radius:15px !important;color:", " !important;border-color:", " !important;padding-right:1px !important;padding-top:1px !important;padding-bottom:1px !important;padding-left:12px !important;font-weight:300 !important;"], THUNDERDOME, THUNDERDOME);
  const StyledImage = styled(UIImage).withConfig({
    displayName: "AdsAcademyVideoCTA__StyledImage",
    componentId: "sc-7euzkv-1"
  })(["position:absolute;left:83%;top:15%;"]);
  const StyledToolTip = styled(UITooltip).withConfig({
    displayName: "AdsAcademyVideoCTA__StyledToolTip",
    componentId: "sc-7euzkv-2"
  })(["max-width:512px !important;"]);

  if (!inVariant) {
    return null;
  }

  const AcademyButton = () => /*#__PURE__*/_jsxs(UIFlex, {
    align: 'center',
    children: [/*#__PURE__*/_jsx(StyledToolTip, {
      headingText: /*#__PURE__*/_jsxs(UIFlex, {
        align: 'center',
        children: [/*#__PURE__*/_jsx(UIImage, {
          responsive: false,
          className: "m-right-1",
          src: playEmbedAcademyExp,
          width: "20px"
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "embeddedAcademy.tooltip.title"
          })
        })]
      }),
      title: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(UILink, {
          href: layout.link,
          external: true,
          iconProps: {
            className: 'hidden'
          },
          children: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(UIImage, {
              src: layout.image
            }), /*#__PURE__*/_jsx(StyledImage, {
              src: externallinkEmbedAcademyExp
            })]
          })
        }), /*#__PURE__*/_jsx(H5, {
          className: "m-top-2 m-bottom-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `embeddedAcademy.${option}.toolTipMessage`
          })
        })]
      }),
      disabled: !imageReady,
      children: /*#__PURE__*/_jsxs(StyledButton, {
        href: layout.link,
        external: true,
        iconProps: {
          className: 'hidden'
        },
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `embeddedAcademy.${option}.buttonMessage`
        }), /*#__PURE__*/_jsx(UIImage, {
          responsive: false,
          src: playEmbedAcademyExp,
          width: "20px"
        })]
      })
    }), showDetails && /*#__PURE__*/_jsx(Small, {
      use: "help",
      className: "p-all-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `embeddedAcademy.${option}.details`
      })
    })]
  });

  return option === ACADEMY_ACCOUNTS ? inVariant && /*#__PURE__*/_jsxs("div", {
    className: "m-top-12",
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embeddedAcademy.accounts.header"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embeddedAcademy.accounts.description"
      })
    }), /*#__PURE__*/_jsx(AcademyButton, {})]
  }) : /*#__PURE__*/_jsx(AcademyButton, {});
}